import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'CRM',
    allowedRoles: ['superadmin', 'cde_admin', 'cde_manager', 'busdev', 'collab', 'm_com', 'admin']
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:home-bold',
    route: '/crm/crm-dashboard',
    allowedRoles: ['superadmin', 'cde_admin', 'cde_manager', 'busdev', 'collab', 'm_com', 'admin']
  },
  {
    displayName: 'Opportunities',
    iconName: 'solar:check-circle-broken',
    allowedRoles: ['superadmin', 'cde_admin', 'cde_manager', 'busdev', 'collab', 'm_com', 'admin'],
    route: '/crm/crm-opportunities',
    /*children: [
      {
        displayName: 'All Opportunities',
        iconName: 'solar:folder-check-broken',
        route: '/crm/crm-opportunities',
      },
      {
        displayName: 'New Opportunity',
        iconName: 'solar:add-folder-broken',
        route: '/crm/crm-new-opportunity',
      },
    ],*/
  },
  {
    displayName: 'Appointments',
    iconName: 'solar:clapperboard-text-linear',
    allowedRoles: ['superadmin', 'cde_admin', 'cde_manager', 'busdev', 'collab', 'm_com', 'admin'],
    route: '/crm/crm-all-appointments',
    /*children: [
      {
        displayName: 'All Appointments',
        iconName: 'solar:calendar-search-broken',
        route: '/crm/crm-all-appointments',
      },
      {
        displayName: 'New Appointment',
        iconName: 'solar:clapperboard-edit-linear',
        route: '/crm/crm-new-appointment',
      },
    ],*/
  },
  {
    displayName: 'CDE Management',
    iconName: 'solar:command-broken',
    route: '/crm/crm-cde-management',
    allowedRoles: ['superadmin', 'cde_admin', 'cde_manager', 'admin']
  },
  {
    navCap: 'Billing',
    allowedRoles: ['superadmin', 'billing', 'admin', 'billing_manager', 'billing-kpi']
  },
  // Billing menu reorganised on 2026-10-28: routes in core/services/billing-navigation-rules.ts.
  {
    displayName: 'Overview',
    iconName: 'solar:home-bold',
    route: '/billing/overview',
    allowedRoles: ['superadmin', 'billing', 'admin']
  },
  {
    displayName: 'Billing requests',
    iconName: 'solar:document-add-bold',
    route: '/billing/billing-requests',
    allowedRoles: ['superadmin', 'billing', 'admin']
  },
  {
    displayName: 'Time management',
    iconName: 'solar:sort-by-time-bold',
    route: '/billing/dashboard-billing-time-management',
    allowedRoles: ['superadmin', 'admin', 'billing', 'timemanager']
  },
  {
    // No leading slash: nav-item unfolds a group whose `/${route}` prefixes the current URL.
    displayName: 'Pennylane',
    iconName: 'solar:card-bold',
    route: 'billing/pennylane',
    allowedRoles: ['superadmin', 'billing', 'admin'],
    children: [
      {
        displayName: 'Billing tracking',
        iconName: 'solar:chart-bold',
        route: '/billing/pennylane/billing-tracking',
        allowedRoles: ['superadmin', 'billing', 'admin']
      },
      {
        displayName: 'Subscriptions',
        iconName: 'solar:refresh-circle-bold',
        route: '/billing/pennylane/subscriptions',
        allowedRoles: ['superadmin', 'billing', 'admin']
      },
      {
        displayName: 'Recovery',
        iconName: 'solar:danger-circle-bold',
        route: '/billing/pennylane/recovery',
        allowedRoles: ['superadmin', 'billing', 'admin']
      },
    ],
  },
  {
    // Same roles as canAccessBillingKpi() (BillingGuard) and Billing_kpi_access_rules (API).
    displayName: 'KPI',
    iconName: 'solar:graph-up-bold',
    route: '/billing/kpi',
    allowedRoles: ['superadmin', 'billing', 'billing_manager', 'billing-kpi']
  },
  {
    displayName: 'Settings',
    iconName: 'tabler:tool',
    route: '/billing/billing-settings',
    allowedRoles: ['superadmin', 'billing']
  },
  {
    navCap: 'Execution',
    allowedRoles: ['superadmin', 'admin', 'exec', 'm_exec', 'exec-payment', 'exec_payment']
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:home-bold',
    route: '/execution/execution-dashboard',
    allowedRoles: ['superadmin', 'admin', 'exec', 'm_exec']
  },
  {
    displayName: 'All live deals',
    iconName: 'tabler:progress',
    route: '/execution/all-live-deals',
    allowedRoles: ['superadmin', 'admin', 'exec', 'm_exec']
  },
  {
    displayName: 'All closed deals',
    iconName: 'tabler:progress-check',
    route: '/execution/closed-deals',
    allowedRoles: ['superadmin', 'admin', 'exec', 'm_exec']
  },
  {
    displayName: 'Notice Issuer import',
    iconName: 'tabler:file-spreadsheet',
    route: '/execution/iban-jm-notice',
    allowedRoles: ['superadmin', 'm_exec']
  },
  {
    // Same roles as the export guard in Wp_stats_rules::export_roles(): the menu
    // must not offer a page that answers 403. `admin` is deliberately absent.
    displayName: 'WP statistics',
    iconName: 'tabler:report-analytics',
    route: '/execution/wp-statistics',
    allowedRoles: ['superadmin', 'mega_admin', 'exec', 'm_exec']
  },
  {
    // Super admins only: same roles as ContractMergeGuard and Cover_ai_contract_merge_rules::PAGE_ROLES
    // (API). Exec and Exec managers merge from the deal's Contract-to-Cover tab.
    displayName: 'Contract merge',
    iconName: 'tabler:git-merge',
    route: '/execution/tools/contract-merge',
    allowedRoles: ['superadmin']
  },
  {
    navCap: 'KYC',
    allowedRoles: ['superadmin', 'admin', 'kyc_bo', 'ext_kyc_bo', 'kyc_validator']
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:home-bold',
    route: '/kyc/kyc-dashboard',
    allowedRoles: ['superadmin', 'admin', 'kyc_bo', 'ext_kyc_bo', 'kyc_validator']
  },
  {
    displayName: 'KYC company',
    iconName: 'solar:buildings-3-bold-duotone',
    route: '/kyc/kyc-companies',
    allowedRoles: ['superadmin', 'admin', 'kyc_bo', 'ext_kyc_bo', 'kyc_validator']
  },
  {
    displayName: 'KYC lenders',
    iconName: 'solar:buildings-broken',
    route: '/kyc/kyc-lenders',
    allowedRoles: ['superadmin', 'admin', 'kyc_bo', 'ext_kyc_bo', 'kyc_validator']
  },
  {
    displayName: 'Dataroom documents',
    iconName: 'solar:document-add-bold',
    route: '/kyc/kyc-dataroom-document-catalog',
    allowedRoles: ['superadmin', 'admin', 'kyc_bo', 'kyc_validator']
  },
  {
    navCap: 'Payment',
    allowedRoles: ['superadmin', 'payment_agent', 'payment_manager']
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:home-bold',
    route: '/payment/payment-dashboard',
    allowedRoles: ['superadmin', 'payment_agent', 'payment_manager']
  },
  {
    displayName: 'IBAN JM',
    iconName: 'tabler:paywall',
    route: '/payment/iban-jm',
    allowedRoles: ['superadmin']
  },
  {
    displayName: 'Notice imports',
    iconName: 'tabler:file-spreadsheet',
    route: '/payment/iban-jm-notice',
    allowedRoles: ['superadmin', 'admin', 'payment_agent', 'payment_manager']
  },
  {
    displayName: 'Debit account requests',
    iconName: 'tabler:building-bank',
    route: '/payment/debit-account-requests',
    allowedRoles: ['superadmin']
  },
  {
    displayName: 'JP Morgan debit accounts',
    iconName: 'tabler:credit-card',
    route: '/payment/debit-accounts',
    allowedRoles: ['superadmin', 'payment_agent', 'payment_manager']
  },
  {
    displayName: 'Activities',
    iconName: 'solar:history-bold',
    route: '/payment/activities',
    allowedRoles: ['superadmin']
  },
  {
    navCap: 'Contact',
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:home-bold',
    route: '/contact/contact-dashboard',
  },
  {
    displayName: 'All companies',
    iconName: 'solar:buildings-3-bold-duotone',
    route: '/contact/all-companies',
  },
  {
    displayName: 'All Management Companies',
    iconName: 'solar:ranking-bold-duotone',
    route: '/contact/all-management-companies',
  },
  {
    displayName: 'All contacts',
    iconName: 'solar:phone-calling-bold',
    route: '/contact/all-contacts',
  },
  {
    displayName: 'All lenders',
    iconName: 'solar:user-check-rounded-broken',
    route: '/contact/all-lenders',
  },
  {
    // Tools: open to every signed-in user (no allowedRoles, no module guard).
    navCap: 'Tools',
  },
  {
    displayName: 'PDF anonymizer',
    iconName: 'solar:shield-user-bold-duotone',
    route: '/tools/pdf-anonymizer',
  },
  {
    navCap: 'Support',
  },
  {
    displayName: 'FAQ',
    iconName: 'solar:question-square-bold-duotone',
    route: '/faq',
  },
  {
    displayName: 'IT Support',
    iconName: 'solar:headphones-round-sound-bold-duotone',
    route: '/it-support',
  },
  {
    displayName: 'Opportunity lifecycle',
    iconName: 'solar:routing-2-bold-duotone',
    route: '/opportunity-lifecycle',
  },
  {
    displayName: 'Data register (GDPR)',
    iconName: 'solar:shield-user-bold-duotone',
    route: '/data-register',
  },
  {
    navCap: 'KPI',
    allowedRoles: ['superadmin', 'admin', 'kpi-manager']
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:chart-2-bold-duotone',
    route: '/kpi/kpi-dashboard',
    allowedRoles: ['superadmin', 'admin', 'kpi-manager']
  },
  /*{
    displayName: 'Company',
    iconName: 'solar:buildings-3-bold-duotone',
    route: '/kpi/kpi-company',
    allowedRoles: ['superadmin', 'admin', 'kpi-manager']
  },
  {
    displayName: 'Contact',
    iconName: 'solar:notebook-line-duotone',
    route: '/kpi/kpi-contact',
    allowedRoles: ['superadmin', 'admin', 'kpi-manager']
  },*/
  {
    navCap: 'Administration',
    allowedRoles: ['superadmin', 'admin']
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:home-bold',
    route: '/admin/admin-dashboard',
    allowedRoles: ['superadmin', 'admin']
  },
  {
    // Living reference of the design system: tokens, badges, search field, dialogs, with code.
    displayName: 'UI Kit',
    iconName: 'solar:palette-bold-duotone',
    route: '/admin/ui-kit',
    allowedRoles: ['superadmin', 'admin']
  },
  {
    displayName: 'Users & Roles',
    iconName: 'solar:users-group-rounded-bold',
    allowedRoles: ['superadmin', 'admin'],
    children: [
      {
        displayName: 'Users',
        iconName: 'solar:user-check-rounded-broken',
        route: '/admin/users',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Roles users',
        iconName: 'solar:shield-user-line-duotone',
        route: '/admin/roles',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'role User editor ',
        iconName: 'solar:shield-user-line-duotone',
        route: '/admin/user-roles-editor',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Roles Afs',
        iconName: 'solar:shield-user-line-duotone',
        route: '/admin/role-afs',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Actions Utilisateurs',
        iconName: 'solar:history-bold',
        route: '/admin/users-actions',
        allowedRoles: ['superadmin', 'admin']
      },
    ],
  },
  {
    displayName: 'Monitoring',
    iconName: 'solar:monitor-bold',
    allowedRoles: ['superadmin', 'admin'],
    children: [
      {
        displayName: 'Pappers API Usage',
        iconName: 'solar:chart-2-bold',
        route: '/admin/pappers-api-monitoring',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'FAQ Usage',
        iconName: 'solar:chat-round-dots-bold',
        route: '/admin/faq-usage-monitoring',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Email Bodies Monitor',
        iconName: 'solar:letter-bold',
        route: '/admin/email-bodies-monitor',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'AI Cover Workers',
        iconName: 'solar:pulse-bold',
        route: '/admin/cover-ai-workers',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'System Monitoring',
        iconName: 'solar:chart-square-bold',
        route: '/admin/monitoring',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Application Logs',
        iconName: 'solar:document-text-bold',
        route: '/admin/app-logs',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Ansible Monitoring',
        iconName: 'solar:programming-bold',
        route: '/admin/ansible-monitoring',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Adoption Monitoring',
        iconName: 'solar:graph-up-bold',
        route: '/admin/adoption-monitoring',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Qualité des Données',
        iconName: 'solar:shield-check-bold-duotone',
        route: '/admin/qdd-dashboard',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Redis Monitor',
        iconName: 'solar:database-bold-duotone',
        route: '/admin/redis-dashboard',
        allowedRoles: ['superadmin', 'admin']
      },
    ],
  },
  {
    displayName: 'Configuration',
    iconName: 'solar:settings-bold',
    allowedRoles: ['superadmin', 'admin'],
    children: [
      {
        displayName: 'Product Fees',
        iconName: 'solar:shield-user-line-duotone',
        route: '/admin/product-fees',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Config API',
        iconName: 'solar:settings-bold',
        route: '/admin/config-api',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Configuration ArturPro',
        iconName: 'solar:settings-bold',
        route: '/admin/config-ap',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'Email Send Exceptions',
        iconName: 'solar:letter-unread-bold',
        route: '/admin/email-exceptions',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        displayName: 'LEI Exception Requests',
        iconName: 'solar:shield-check-broken',
        route: '/admin/lei-derogation-requests',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        // AdminGuard (every /admin page) only lets admin / superadmin through.
        displayName: 'Entity Matching',
        iconName: 'solar:users-group-rounded-bold',
        route: '/admin/entity-matching',
        allowedRoles: ['superadmin', 'admin']
      },
      {
        // Same list as DATAROOM_GED_ADMIN_ROLES: writing a `deny` on a family is
        // the most powerful action of the GED, and `admin` is not on it.
        displayName: 'GED Access Policy',
        iconName: 'solar:folder-security-bold',
        route: '/admin/ged-access-policy',
        allowedRoles: ['superadmin', 'mega_admin']
      },
      {
        displayName: 'Gemini Chat',
        iconName: 'solar:chat-round-bold',
        route: '/admin/gemini-test',
        allowedRoles: ['superadmin', 'admin']
      },
    ],
  },

  {
    navCap: 'Continuité PCA',
    allowedRoles: ['role-pca'],
    pcaMonitorOnly: true,
  },
  {
    displayName: 'PCA Continuity',
    iconName: 'solar:shield-check-bold-duotone',
    route: '/admin/pca-dashboard',
    allowedRoles: ['role-pca'],
    pcaMonitorOnly: true,
    subtext: 'Production standby failover',
  },


  // Client Space administration — visible only to the adminclientspace role
  // (superadmin/admin also allowed). Filtered by allowedRoles in full.component.ts.
  {
    navCap: 'Client Space',
    allowedRoles: ['adminclientspace', 'superadmin', 'admin']
  },
  {
    displayName: 'Client Space',
    iconName: 'solar:users-group-two-rounded-bold-duotone',
    // CSA back-office only. The client portal itself is a separate application
    // served on its own domain, not by ArturPro. Keep this list in step with
    // AuthService.isClientSpaceAdmin() (the route guard) and Csa_controller::require_csa().
    route: '/admin-client-space/spaces',
    allowedRoles: ['adminclientspace', 'superadmin', 'admin', 'busdev', 'exec', 'm_exec', 'crm_manager']
  },

];
